export interface LinkItem {
  title: string;
  href: string;
}

export const bTechAdmissionLinks: LinkItem[] = [
  {
    title: "Physical reporting from 20th Aug 2025 to 23rd Aug 2025",
    href: "/docs/B.Tech._Admission_Guidelines_for_2025-26_Students.pdf",
  },
  {
    title:
      "Admission form for B.Tech students allotted through JoSAA/CSAB Counselling 2025",
    href: "https://forms.gle/HhFLbufmLBh8FwW56",
  },
  {
    title: "Tution Fee Structure 2026-2027",
    href: "/docs/Tution_Fee_AY_2026_27_08042026_1713.pdf",
  },
  {
    title: "Hostel Fee Structure 2026-2027",
    href: "/docs/Hostel_Fee_AY_2026_27_080427_1714.pdf",
  },
  {
    title: "Fee Refund Policy",
    href: "/docs/Fee-Refund.pdf",
  },
  {
    title: "PM VIDYA LAXMI EDUCATION LOAN SCHEME - CANARA BANK",
    href: "/docs/PM_VIDYA_LAXMI_EDUCATION_LOAN_-CANARA_BANK_FOR_IIIT_DHARWAD.pdf",
  },
  {
    title: "Scholarships",
    href: "/scholarship/",
  },
  {
    title: "FAQ's",
    href: "/faq/",
  },
  /*
  {
    title:
      "Available Seats – CSAB 2025 Counselling",
    href: "/docs/Notice_.pdf",
  },
  {
    title:
      "Physical Reporting Dates for JoSAA/CSAB-2025 Allotted Students (20th – 23rd Aug 2025)",
    href: "/docs/Circular.pdf",
  },
  {
    title:
      "Revised Schedule of Events of JoSAA 2025 (ONLINE REPORTING) (as on June 19th 2025)",
    href: "https://drive.google.com/file/d/1vWaguAmsSruPI7yH8hXst5uJ-eCs3Ujg/view",
  },
  {
    title: "CSAB timeline (Page 9-10)",
    href: "https://cdnbbsr.s3waas.gov.in/s305a70454516ecd9194c293b0e415777f/uploads/2025/05/2025052928.pdf",
  },
  {
    title: "Guidelines for Admission 2024 | (2025 TBD)",
    href: "/docs/Guidelines%20for%20admission%202024-25.pdf",
  },
  {
    title: "For General Queries you can contact here",
    href: "https://docs.google.com/document/d/1BNdjNk8k87dhHIWza4TMKPCq_YCCZgOG",
  },
  */
];

export const quickLinks: LinkItem[] = [
  {
    title: "Tution Fee for the batch 2026-2027",
    href: "/docs/Tution_Fee_AY_2026_27_08042026_1713.pdf",
  },
  {
    title: "Hostel Fee for the batch 2026-2027",
    href: "/docs/Hostel_Fee_AY_2026_27_080427_1714.pdf",
  },
  {
    title: "Fee Refund Policy",
    href: "/docs/Fee-Refund.pdf",
  },
  {
    title: "Scholarships",
    href: "/scholarship/",
  },
  {
    title: "PM VIDYA LAXMI EDUCATION LOAN SCHEME - CANARA BANK",
    href: "/docs/PM_VIDYA_LAXMI_EDUCATION_LOAN_-CANARA_BANK_FOR_IIIT_DHARWAD.pdf",
  },
  {
    title: "Hostel Facility for 2026 batch students (TBD)",
    href: "#",
  },
  {
    title:
      "State wise List of Reporting Centers for Physical Verification of PwD Candidates [for NIT+ System Only] JoSAA/CSAB 2026",
    href: "/docs/State-wise-List-of-Reporting-Centers.pdf",
  },
  {
    title: "FAQ's",
    href: "/faq/",
  },
  {
    title: "CPI to Percentage Conversion Notes",
    href: "/docs/6._CPI_to_Percentage_Conversion_notes.pdf",
  },
];

export const eligibilityCriteria: LinkItem[] = [
  {
    title: "Guidelines for students alloted through JoSAA/CSAB Counselling",
    href: "/docs/B.Tech._Admission_Guidelines_for_2026-27_Students.pdf",
  },
  /*{
    title: "Undertaking to be signed by students and their parents",
    href: "/docs/undertaking_2023.pdf",
  }*/
  {
    title:
      "Performance in Class XII for candidates seeking admission in IIIT Dharwad - 2026",
    href: "/docs/Performance_in%20Class_XII_2026.pdf",
  },
  {
    title:
      "Category wise Top-20 percentile cut-off marks out-of total 500 marks for 2026",
    href: "https://cdnbbsr.s3waas.gov.in/s313111c20aee51aeb480ecbd988cd8cc9/uploads/2026/06/2026060941.pdf",
  },
];

export const programsOffered: LinkItem[] = [
  {
    title:
      "Computer Science and Engineering (Institute Code 316 and Program Code 4110)",
    href: "/academics/departments",
  },
  {
    title:
      "Electronics and Communication Engineering (Institute Code 316 and Program Code 4114)",
    href: "/academics/departments/",
  },
  {
    title:
      "Data Science and Artificial Intelligence (Institute Code 316 and Program Code 4181)",
    href: "/academics/departments/",
  },
  {
    title: "AI and Computing (Institute Code 316 and Program Code TBA)",
    href: "#",
  },
];
